<template>
	<div class="card">
		<div class="card-header">
			<div class="d-flex flex-wrap align-items-center gap-2">
				<span class="fs-6">Progres Kelengkapan Data Rinci Siswa</span>
				<el-select
					v-model="semester"
					value-key="semester_id"
					placement="bottom-end"
					:placeholder="semesterAktif.nama || 'Semester'"
					class="ms-auto"
					style="width: 200px"
					v-if="isPengelolaOrStaf">
					<el-option v-for="s in listSemester" :key="s" :label="s.nama" :value="s" />
					<template #empty>Data tidak ditemukan</template>
				</el-select>
				<el-input :placeholder="semesterAktif.nama || 'Semester'" readonly class="ms-auto" style="width: 200px" v-else />
			</div>
		</div>
		<div class="card-body" v-loading="loading">
			<div class="row g-1 align-items-center justify-content-center" v-if="isPengelolaOrStaf">
				<span class="fs-5 col-auto text-center">Persentase Kelengkapan Total:</span>
				<transition name="slide-up" mode="out-in">
					<span :key="persenTotal" class="fs-4 col-auto" :class="persenTotalClass">{{ persenTotal || "-" }}%</span>
				</transition>
			</div>
			<hr v-if="isPengelolaOrStaf" />
			<el-table :data="persenPerRombel" table-layout="auto" border stripe header-cell-class-name="text-center bg-light" row-key="rombel_id">
				<template #empty>
					<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" label="No." align="center" width="10" />
				<el-table-column prop="nama" label="Rombel">
					<template #default="{ row }">
						<div class="hstack gap-1 justify-content-between">
							<span class="text-nowrap">{{ row.nama }}</span>
							<el-tooltip :content="'Lihat detail kelengkapan ' + row.nama">
								<router-link :to="{ name: 'rombel', params: { rombelId: row.rombel_id } }">
									<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
								</router-link>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="nama_wali_kelas" label="Wali Kelas" />
				<el-table-column prop="nama_guru_bk" label="Guru BK" />
				<el-table-column prop="jumlah_siswa_aktif" label="Jumlah Siswa Aktif" align="center" sortable class-name="fw-bold" />
				<el-table-column label="Persentase Kelengkapan Data" align="center">
					<el-table-column prop="persen_detail_siswa" label="Detail Siswa" align="center" sortable label-class-name="small">
						<template #default="{ row }">
							<span :key="row.persen_detail_siswa" :class="row.persen_detail_siswa_class">{{ row.persen_detail_siswa }}%</span>
						</template>
					</el-table-column>
					<el-table-column prop="persen_data_ayah" label="Data Ayah" align="center" sortable label-class-name="small">
						<template #default="{ row }">
							<span :key="row.persen_data_ayah" :class="row.persen_data_ayah_class">{{ row.persen_data_ayah }}%</span>
						</template>
					</el-table-column>
					<el-table-column prop="persen_data_ibu" label="Data Ibu" align="center" sortable label-class-name="small">
						<template #default="{ row }">
							<span :key="row.persen_data_ibu" :class="row.persen_data_ibu_class">{{ row.persen_data_ibu }}%</span>
						</template>
					</el-table-column>
					<el-table-column prop="persen_data_wali" label="Data Wali" align="center" sortable label-class-name="small">
						<template #default="{ row }">
							<span :key="row.persen_total" :class="row.persen_data_wali_class">{{ row.persen_data_wali }}%</span>
						</template>
					</el-table-column>
					<el-table-column prop="persen_total" label="Total" align="center" sortable label-class-name="small" class-name="fw-bold">
						<template #default="{ row }">
							<span :key="row.persen_total" :class="row.persen_total_class">{{ row.persen_total }}%</span>
						</template>
					</el-table-column>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	name: "ProgresRombel",
	data() {
		return {
			listSemester: [],
			semester: null,
			persenTotal: 0,
			persenTotalClass: "",
			persenPerRombel: [],
			loading: true,
			updatedProgresAll: () => {
				if (this.isPengelolaOrStaf) this.getPersentaseTotal();
				this.getPersentasePerRombel();
			},
			updatedProgresSiswa: async (data) => {
				const d = JSON.parse(data);
				const rombelIds = d.rombel_ids || [];
				const row = this.persenPerRombel.find((r) => rombelIds.includes(r.rombel_id));
				if (this.isPengelolaOrStaf) this.getPersentaseTotal();
				const progres = await this.getPersentaseRombelTotal(row.rombel_id);
				if (progres) {
					row.persen_detail_siswa_class = row.persen_detail_siswa !== progres.persen_detail_siswa?.toFixed(2) ? "highlighted " : "";
					row.persen_data_ayah_class = row.persen_data_ayah !== progres.persen_data_ayah?.toFixed(2) ? "highlighted " : "";
					row.persen_data_ibu_class = row.persen_data_ibu !== progres.persen_data_ibu?.toFixed(2) ? "highlighted " : "";
					row.persen_data_wali_class = row.persen_data_wali !== progres.persen_data_wali?.toFixed(2) ? "highlighted " : "";

					row.persen_detail_siswa = progres.persen_detail_siswa?.toFixed(2) || 0;
					row.persen_data_ayah = progres.persen_data_ayah?.toFixed(2) || 0;
					row.persen_data_ibu = progres.persen_data_ibu?.toFixed(2) || 0;
					row.persen_data_wali = progres.persen_data_wali?.toFixed(2) || 0;
					row.persen_total = progres.persen_total?.toFixed(2) || 0;

					row.persen_detail_siswa_class += this.getTextStyle(progres.persen_detail_siswa);
					row.persen_data_ayah_class += this.getTextStyle(progres.persen_data_ayah);
					row.persen_data_ibu_class += this.getTextStyle(progres.persen_data_ibu);
					row.persen_data_wali_class += this.getTextStyle(progres.persen_data_wali);
					row.persen_total_class = this.getTextStyle(progres.persen_total) + " highlighted";

					setTimeout(() => {
						row.persen_detail_siswa_class = this.getTextStyle(progres.persen_detail_siswa);
						row.persen_data_ayah_class = this.getTextStyle(progres.persen_data_ayah);
						row.persen_data_ibu_class = this.getTextStyle(progres.persen_data_ibu);
						row.persen_data_wali_class = this.getTextStyle(progres.persen_data_wali);
						row.persen_total_class = this.getTextStyle(progres.persen_total);
					}, 600);
				}
			},
		};
	},
	computed: {
		semesterAktif() {
			return this.$store.getters.getSemester;
		},
		isPengelolaOrStaf() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "superadmin", "admin-kesiswaan", "admin-buku-induk", "pengelola", "staf"].includes(r.role));
		},
	},
	watch: {
		semester: {
			immediate: true,
			async handler(val) {
				if (val) {
					this.loading = true;
					await new Promise((resolve) => {
						setTimeout(async () => {
							if (this.isPengelolaOrStaf) {
								await this.getPersentaseTotal();
							}
							await this.getPersentasePerRombel();
							resolve();
						}, 500);
					});
					this.loading = false;
				}
			},
		},
	},
	mounted() {
		if (this.isPengelolaOrStaf) {
			this.getListSemester();
		}
		this.semester = this.semesterAktif;
		this.$ws.main.on("progres-siswa:updated", this.updatedProgresAll);
		this.$ws.main.on("detail-siswa:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-ayah:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-ibu:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-wali:updated", this.updatedProgresSiswa);
	},
	beforeUnmount() {
		this.$ws.main.off("progres-siswa:updated");
		this.$ws.main.off("detail-siswa:updated");
		this.$ws.main.off("data-ayah:updated");
		this.$ws.main.off("data-ibu:updated");
		this.$ws.main.off("data-wali:updated");
	},
	methods: {
		async getListSemester() {
			try {
				const { data } = await this.$defaultApi.post("/list/semester");

				this.listSemester = data.semester;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async getPersentaseTotal() {
			try {
				const { data } = await this.$defaultApi.post("/progres/total", {
					semester_id: this.semester.semester_id,
				});

				const result = data.progres_total;
				this.persenTotal = result?.toFixed(2) || result;
				this.persenTotalClass = this.getTextStyle(result);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async getPersentasePerRombel() {
			try {
				const { data } = await this.$defaultApi.post("/progres/rombel/all", {
					semester_id: this.semester.semester_id,
				});

				const result = data.progres_per_rombel || [];
				result.forEach((r) => {
					r.persen_detail_siswa = r.persen_detail_siswa?.toFixed(2) || 0;
					r.persen_data_ayah = r.persen_data_ayah?.toFixed(2) || 0;
					r.persen_data_ibu = r.persen_data_ibu?.toFixed(2) || 0;
					r.persen_data_wali = r.persen_data_wali?.toFixed(2) || 0;
					r.persen_total = r.persen_total?.toFixed(2) || 0;

					r.persen_detail_siswa_class = this.getTextStyle(r.persen_detail_siswa);
					r.persen_data_ayah_class = this.getTextStyle(r.persen_data_ayah);
					r.persen_data_ibu_class = this.getTextStyle(r.persen_data_ibu);
					r.persen_data_wali_class = this.getTextStyle(r.persen_data_wali);
					r.persen_total_class = this.getTextStyle(r.persen_total);
				});
				this.persenPerRombel = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		async getPersentaseRombelTotal(rombel_id) {
			try {
				const { data } = await this.$defaultApi.post("/progres/rombel/total", {
					rombel_id,
				});

				return data.progres_rombel;
			} catch (error) {
				console.error(error);
				return null;
			}
		},
		getTextStyle(val) {
			if (val > 85) return "text-success";
			if (val > 65) return "text-success-emphasis";
			if (val > 35) return "text-warning";
			return "text-danger";
		},
	},
};
</script>

<style scoped></style>
